import * as Yup from "yup"
import { reverseShape } from "Components/shared/helpers/reverse-shape"
import {
  decimal,
  date,
  validString,
  dateRange,
  valueRange
} from "Components/shared/helpers/validations"

const rateFields = Yup.object().shape(
    reverseShape({
        valueFrom: decimal.required(),
        valueTo: decimal.required().concat(valueRange),
        charge: decimal.required(),
    })
)

const insuranceCharges = Yup.array(rateFields.required())

const InsuranceRateFormSchema = Yup.object().shape(
    reverseShape({
        code: validString.optional(), // create version
        settingID: validString.optional(), // edit version
        validFrom: date.required(),
        validTo: date.required().concat(dateRange),
        insuranceCharges: insuranceCharges.required()
    })
)

export default InsuranceRateFormSchema
